module.exports = __webpack_public_path__ + "static/media/TANKARVEK.36119244.pdf";